import script from "./Embed.vue?vue&type=script&setup=true&lang=js"
export * from "./Embed.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__